import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

const EMPTY_ICON_SIZE = 48;

export interface CatalogSearchEmptyStateProps {
  actionLabel: string;
  description?: string;
  onAction: () => void;
  title: string;
}

export const CatalogSearchEmptyState: React.FC<
  CatalogSearchEmptyStateProps
> = ({ actionLabel, description, onAction, title }) => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={actionLabel}
          onPress={onAction}
          size={ButtonSize.Medium}
          style={styles.actionButton}
          variant={ButtonVariant.Secondary}
        >
          {actionLabel}
        </Button>
      }
      description={description}
      iconElement={
        <EmptyDottedIcon
          fill={theme.sk.color.icon.primary}
          height={EMPTY_ICON_SIZE}
          width={EMPTY_ICON_SIZE}
        />
      }
      title={title}
    />
  );
};

const useStyles = createStyles((theme) => ({
  actionButton: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
